import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const fleetColors = {
  success: tokens.status.success.fg,
  warning: tokens.accent.base,
  yellow: tokens.status.warning.fg,
  danger: tokens.status.danger.fg,
  info: tokens.status.info.fg,
  purple: tokens.status.info.fg,
  trackBg: tokens.surface.raised,
  cardSurface: tokens.surface.glass,
  cardInner: tokens.surface.inset,
  divider: tokens.border.hairline,
}

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const DashGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const CompositionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
`

export const CategoryTile = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 0.75rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.base};
  }
`

export const TileIcon = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.accent.soft};
  color: ${tokens.accent.base};

  svg {
    width: 1.1rem;
    height: 1.1rem;
  }
`

export const TileText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const TileCount = styled.span`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  line-height: 1.1;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const TileName = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
